import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/community/visibility.svg'
import _imports_2 from '@/assets/img/community/document.svg'
import _imports_3 from '@/assets/img/management/comment.svg'
import _imports_4 from '@/assets/img/camera.svg'
import _imports_5 from '@/assets/img/community/gallery.svg'
import _imports_6 from '@/assets/img/community/attachments.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue ms-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "listButtonContainer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = { class: "fs_14 spaceCadet ms-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", { src: _imports_6 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue",
          localizedKey: "app_modifica",
          text: "Modifica"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ]),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visibility()))
      }, [
        _hoisted_7,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_visibilita",
          text: "Visibilità"
        }),
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.isEvent)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "listButton genericShadow",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editEvent()))
          }, [
            _hoisted_9,
            _createVNode(_component_localized_text, {
              class: "fs_14 spaceCadet ms-3",
              localizedKey: "app_dettaglievento",
              text: "Dettagli evento"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.description()))
      }, [
        _hoisted_10,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_descrizione",
          text: "Descrizione"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.backgroundModal()))
      }, [
        _hoisted_11,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_copertina",
          text: "Copertina"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.logoModal()))
      }, [
        _hoisted_12,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_logo",
          text: "Logo"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.galleryModal()))
      }, [
        _hoisted_13,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_gallery",
          text: "Gallery"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.allegatiModal()))
      }, [
        _hoisted_14,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_allegati",
          text: "Allegati"
        })
      ])
    ])
  ]))
}